import { Star, StarHalf } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  value: number; // 0-5
  size?: number;
  className?: string;
}

const StarRating = ({ value, size = 14, className }: StarRatingProps) => {
  const safe = Math.max(0, Math.min(5, value || 0));
  const full = Math.floor(safe);
  const hasHalf = safe - full >= 0.25 && safe - full < 0.75;
  const fullCount = hasHalf ? full : Math.round(safe);
  const empty = 5 - fullCount - (hasHalf ? 1 : 0);

  return (
    <div className={cn("inline-flex items-center gap-0.5", className)} aria-label={`${safe.toFixed(1)} out of 5 stars`}>
      {Array.from({ length: fullCount }).map((_, i) => (
        <Star key={`f-${i}`} style={{ width: size, height: size }} className="fill-ocean text-ocean" />
      ))}
      {hasHalf && (
        <StarHalf style={{ width: size, height: size }} className="fill-ocean text-ocean" />
      )}
      {Array.from({ length: empty }).map((_, i) => (
        <Star key={`e-${i}`} style={{ width: size, height: size }} className="text-ocean/30" />
      ))}
    </div>
  );
};

export default StarRating;
